import React, { useEffect, useRef, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    Button,
    Grid,
    IconButton,
    LinearProgress,
    Modal,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';
import './programFileList.css';
import PageHeader from '../../includes/PageHeader';
import showMessage from '../../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { Box } from '@mui/system';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { format } from 'date-fns';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../../configs/messages';
import mn from 'date-fns/locale/mn';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import { sendJsonData } from '../../../../helpers/sendJsonData';
import EpgDetail from '../../Epg/EpgDetail';
import renderCellExpand from '../../../feature/GridCellExpand';
import {
    LOCAL_STORAGE_USER,
    SESSION_NAME,
} from '../../../../configs/constants';
import { SendIds } from '../../../../helpers/sendIds';
import { Download, UploadFile } from '@mui/icons-material';
import { SendId } from '../../../../helpers/sendId';
import { sendFileData } from '../../../../helpers/sendFileData';
import { getEpgList } from '../../../../helpers/getEpgList';

export function ProgramFileList() {
    const columns = [
        {
            field: 'originalName',
            headerName: 'Файлын нэр',
            flex: 1,
        },
        {
            field: 'channelName',
            headerName: 'Сувгийн нэр',
            flex: 1,
            valueGetter: (params) => params.row.channel?.name || 'Нэр байхгүй',
        },
        {
            field: 'broadcastWeek',
            headerName: 'Файл огноо',
            flex: 1,
        },
        {
            field: 'approveStatus',
            headerName: 'Баталсан эсэх',
            flex: 1,
            //
            renderCell: (params) => {
                const approveStatus = params.row.approveStatus;
                const status = params.row.status;

                if (approveStatus === 'pending' && status === 'fail') {
                    return <div style={{ color: 'red' }}>Батлах боломжгүй</div>;
                } else if (approveStatus === 'pending') {
                    return (
                        <div style={{ color: 'orange' }}>Хүлээгдэж байна</div>
                    );
                } else if (approveStatus === 'approved') {
                    return <div style={{ color: 'green' }}>Батлагдсан</div>;
                } else {
                    return null;
                }
            },
        },
        {
            field: 'createdAt',
            headerName: 'Хуулсан огноо',
            flex: 1,
        },
        // {
        //     field: 'description',
        //     headerName: 'Тайлбар',
        //     flex: 1,
        //     renderCell: renderCellExpand,
        // },
        {
            field: 'status',
            headerName: 'Файл хуулсан төлөв',
            flex: 1,
        },
        {
            field: 'failReason',
            headerName: 'Файлын алдаа',
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: 'approve',
            headerName: 'Батлах',

            renderCell: (params) => {
                return (
                    <div style={{ outline: 'none' }}>
                        {params.row.status === 'success' &&
                        params.row.approveStatus === 'pending' ? (
                            <>
                                <Button
                                    variant="outlined"
                                    autoFocus
                                    color="success"
                                    size="small"
                                    sx={{ fontSize: '9px' }}
                                    onClick={() =>
                                        handleApproveOpen(
                                            params.id,
                                            params.row.originalName,
                                        )
                                    }
                                >
                                    Батлах
                                </Button>
                                <Button
                                    variant="outlined"
                                    autoFocus
                                    color="secondary"
                                    size="small"
                                    sx={{ fontSize: '9px' }}
                                    onClick={() => handleDescOpen(params.id)}
                                >
                                    Буцаах
                                </Button>
                            </>
                        ) : params.row.approveStatus === 'disapproved' ? (
                            <Button
                                variant="outlined"
                                autoFocus
                                color="success"
                                size="small"
                                sx={{ fontSize: '9px' }}
                                onClick={() =>
                                    handleApproveOpen(
                                        params.id,
                                        params.row.originalName,
                                    )
                                }
                            >
                                Батлах
                            </Button>
                        ) : (
                            <>
                                <Button
                                    variant="outlined"
                                    autoFocus
                                    color="success"
                                    disabled
                                    size="small"
                                    sx={{ fontSize: '9px' }}
                                >
                                    Батлах
                                </Button>
                                <Button
                                    variant="outlined"
                                    autoFocus
                                    color="secondary"
                                    sx={{ fontSize: '9px' }}
                                    disabled
                                    size="small"
                                >
                                    Буцаах
                                </Button>
                            </>
                        )}
                    </div>
                );
            },
            flex: 1,
        },

        {
            field: 'edit',
            headerName: 'Дэлгэрэнгүй',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.status === 'success' && (
                            <Tooltip title="Харах">
                                <IconButton
                                    color="secondary"
                                    onClick={() =>
                                        handleOpen(params.row.epgProgramId)
                                    }
                                >
                                    <ReadMoreIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                        {/* <Tooltip title="Татах">
                            <IconButton
                                style={{ color: 'green' }}
                                onClick={() => handleDownload(params.id)}
                            >
                                <Download />
                            </IconButton>
                        </Tooltip> */}
                        <>
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                accept=".csv"
                                style={{ display: 'none' }}
                            />
                            <Tooltip title="засварлах">
                                <IconButton
                                    style={{ color: 'red' }}
                                    onClick={() => handleuploadClick(params.id)}
                                >
                                    <UploadFile />
                                </IconButton>
                            </Tooltip>
                        </>
                    </div>
                );
            },
            flex: 1,
        },
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [programList, setProgramList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(0); // DataGrid uses 0-based page
    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const { enqueueSnackbar } = useSnackbar();
    const [approveInProcess, setApproveInProcess] = useState(false);
    const [disapproveInProcess, setDispproveInProcess] = useState(false);
    const [khRefresh, setKhRefresh] = useState({});
    const [epgId, setEpgId] = useState('');
    const [rowHeight, setRowHeight] = useState(38);
    const [selectedIds, setSelectedIds] = useState([]);
    const [open, setOpen] = useState(false);
    const [descOpen, setDescOpen] = useState(false);
    const [approveOpen, setApproveOpen] = useState(false);
    const [fileId, setfileId] = useState('');
    const [errors, setErrors] = useState({});
    const [description, setDescription] = useState('');
    const [filename, setFilename] = useState('');
    const fileInputRef = useRef(null);
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const [editFileId, setEditFileId] = useState();

    let updatedColumns = [...columns];
    if (user?.role === 'OPERATOR') {
        updatedColumns = updatedColumns.filter(
            (col) => col.field !== 'approve',
        );
    }

    const handleuploadClick = (id) => {
        fileInputRef.current.click();
        setEditFileId(id);
    };

    const handleFileChange = (event) => {
        const files = event.target.files;

        if (files.length > 0) {
            handleUpload(files[0]);
        }
    };

    const handleUpload = (file) => {
        setIsLoading(true);
        if (editFileId) {
            sendFileData(file, `program-file/edit-file/${editFileId}`)
                .then((response) => {
                    console.log('File uploaded successfully:', response.data);
                    showMessage(SUCCESS_MESSAGES.FILEUPDATED, enqueueSnackbar);
                })
                .catch((error) => {
                    console.error('Error uploading file:', error);
                    const message = error.response?.data?.message
                        ? error.response.data.message
                        : error.message;
                    showMessage(message, enqueueSnackbar, 'error');
                })
                .finally(() => {
                    setIsLoading(false);
                    setEditFileId(null);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                });
        }
    };

    useEffect(() => {
        let isActive = true;
        console.log(user?.id);

        const endpoint =
            user?.role === 'OPERATOR'
                ? `program-file/user/${user?.id}`
                : 'program-file';
        getEpgList(endpoint, { page: page + 1, limit: pageSize })
            .then((response) => {
                if (isActive) {
                    const resp = response.data;
                    console.log(resp);
                    const dataArr = resp.data.data || [];
                    dataArr.forEach((data) => {
                        data.createdAt = data.createdAt
                            ? format(
                                  new Date(data.createdAt),
                                  'yyyy-MM-dd HH:mm',
                                  {
                                      locale: mn,
                                  },
                              )
                            : null;
                    });
                    setProgramList(dataArr);
                    setTotalRows(resp.data.total || 0);
                    setCurrentPage(resp.data.page || 1);
                    setTotalPages(resp.data.totalPages || 0);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            });

        return () => {
            isActive = false;
        };
    }, [khRefresh, page, pageSize]);

    // const showDelete = () => {
    //     setShowDeleteValidation(true);
    // };

    // const handleDelete = async () => {
    //     setShowDeleteValidation(false);
    //     try {
    //         await SendIds('/program-file/remove/files', selectedIds, 'DELETE');
    //         setProgramList(prevList => prevList.filter(item => !selectedIds.includes(item.id)));
    //         setSelectedIds([]);
    //         showMessage(SUCCESS_MESSAGES.DELETED_DATA, enqueueSnackbar);
    //         setKhRefresh({});
    //     } catch (error) {
    //         console.error(error);
    //         showMessage(
    //             error.response?.data?.message
    //                 ? error.response.data.message
    //                 : ERROR_MESSAGES.REQUEST_FAIL,
    //             enqueueSnackbar,
    //             'error',
    //         );
    //     }
    // };

    // const handleDownload = (id) => {
    //     if (id) {
    //         SendId(`program-file/download/${id}`, 'PATCH')
    //             .then((response) => {
    //                 const contentType = response.headers['content-type'];
    //                 if (contentType !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    //                     console.error('Invalid file format:', contentType);
    //                     showMessage('The file format is invalid.', enqueueSnackbar, 'error');
    //                     return;
    //                 }

    //                 const url = window.URL.createObjectURL(new Blob([response.data]));
    //                 const link = document.createElement('a');
    //                 link.href = url;
    //                 link.setAttribute('download', 'your_file.xlsx');
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 link.remove();

    //                 showMessage(SUCCESS_MESSAGES.FilEDOWNLOADED, enqueueSnackbar);
    //                 // history.push(ROUTES_LIST.programFileList);
    //                 setKhRefresh({});
    //             })
    //             .catch((error) => {
    //                 console.error(error);
    //                 showMessage(
    //                     error.response?.data?.message
    //                         ? error.response.data.message
    //                         : ERROR_MESSAGES.REQUEST_FAIL,
    //                     enqueueSnackbar,
    //                     'error',
    //                 );
    //             });
    //     }
    // };

    // const handleDeleteCancel = () => {
    //     setShowDeleteValidation(false);
    //     setSelectedIds([]);
    // };
    const handleApprove = () => {
        if (disapproveInProcess) {
            return;
        }
        setApproveInProcess(true);

        sendJsonData(null, `program-file/approve/${fileId}`, true)
            .then(() => {
                handleApproveClose();
                showMessage(SUCCESS_MESSAGES.APPROVED, enqueueSnackbar);
                setKhRefresh({});
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });

        setApproveInProcess(false);
    };
    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;

        tempErrors.description = description ? '' : requiredMessage;

        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };
    const handleDisapprove = (e) => {
        if (approveInProcess) {
            return;
        }
        setDispproveInProcess(true);

        e.preventDefault();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        sendJsonData(
            { description: description },
            `program-file/disapprove/${fileId}`,
            true,
        )
            .then(() => {
                showMessage(SUCCESS_MESSAGES.DISAPPROVED, enqueueSnackbar);
                handleDecsClose();
                // history.push(ROUTES_LIST.programList);
                setKhRefresh({});
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });

        setDispproveInProcess(false);
    };

    const handleOpen = (id) => {
        setEpgId(id);
        setOpen(true);
    };
    const handleDescOpen = (fileId) => {
        setfileId(fileId);
        setDescOpen(true);
    };
    const handleApproveOpen = (fileId, fileName) => {
        setFilename(fileName);
        setfileId(fileId);
        setApproveOpen(true);
    };
    const handleClose = () => setOpen(false);
    const handleDecsClose = () => setDescOpen(false);
    const handleApproveClose = () => setApproveOpen(false);

    const handleInputChange = (e) => setDescription(e.target.value);
    const localizedTextsMap = {
        columnMenuUnsort: 'Ангилаагүй',
        columnMenuSortAsc: 'Өсөхөөр эрэмблэх',
        columnMenuSortDesc: 'Буурахаар эрэмблэх',
        columnMenuFilter: 'Хайх',
        columnMenuHideColumn: 'Нуух',
        columnMenuShowColumns: 'Багана харах',
    };

    return (
        <Grid
            container
            justifyContent="center"
            style={{ height: 630, width: '100%' }}
        >
            <Box sx={{ width: '100%' }}>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <PageHeader pageName="Файлын жагсаалт" showAddNew={false} />
                    <Box display="flex" alignItems="center" gap={2}>
                        <Typography variant="body2" style={{ color: '#666' }}>
                            Хуудас: {currentPage}/{totalPages}
                        </Typography>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => window.location.reload()}
                            style={{
                                padding: '8px 16px',
                            }}
                        >
                            Дахин ачааллах
                        </Button>
                    </Box>
                </Grid>
                {isLoading ? (
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                ) : (
                    <>
                        <DataGrid
                            rows={programList}
                            columns={updatedColumns}
                            pageSize={pageSize}
                            rowsPerPageOptions={[20, 50, 100, 200]}
                            pagination
                            paginationMode="server"
                            rowCount={totalRows}
                            page={page}
                            onPageChange={(newPage) => setPage(newPage)}
                            onPageSizeChange={(newPageSize) =>
                                setPageSize(newPageSize)
                            }
                            checkboxSelection
                            onSelectionModelChange={(newSelection) => {
                                setSelectedIds(newSelection);
                            }}
                            selectionModel={selectedIds}
                            localeText={localizedTextsMap}
                            disableSelectionOnClick
                            rowHeight={rowHeight}
                            sx={{
                                '& .MuiDataGrid-columnHeaders': {
                                    fontSize: '12px',
                                },
                                '& .MuiDataGrid-cell': {
                                    fontSize: '12px',
                                },
                                height: 700,
                            }}
                        />
                        {/* <Box mt={2} display="flex" flexDirection="row" alignItems="center" justifyContent="center" onClick={showDelete} style={{ cursor: 'pointer' }}>
                            <Tooltip title="Устгах">
                                <IconButton
                                    style={{
                                        color: 'red',
                                        border: '2px solid red',
                                        borderRadius: '5px',
                                        backgroundColor: 'rgba(255, 0, 0, 0.1)', 
                                        padding: '8px 12px',
                                        transition: 'background-color 0.3s',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 0, 0, 0.2)'} 
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 0, 0, 0.1)'}
                                >
                                    <DeleteOutlineIcon style={{ marginRight: '5px' }} />
                                    <Typography variant="body1" style={{ color: 'red' }}>
                                        Устгах
                                    </Typography>
                                </IconButton>
                            </Tooltip>
                        </Box> */}
                    </>
                )}
            </Box>
            {/* <Dialog
                open={showDeleteValidation}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Та эдгээр файлыг устгахыг хүсэж байна уу?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Та эдгээр файлыг устгахыг хүсэж байвал &apos;Тийм&apos;
                        товчийг дарна уу.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleDeleteCancel}>
                        Болих
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={handleDelete}
                        autoFocus
                    >
                        Тийм
                    </Button>
                </DialogActions>
            </Dialog> */}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="epg-detail-modal">
                    <EpgDetail epgProgramId={epgId} isEdit={false} />
                </Box>
            </Modal>

            <Modal
                open={descOpen}
                onClose={handleDecsClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="epg-detail-disapprove-modal epg-detail-modal">
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        Буцаах шалтгаанаа бичнэ үү.
                    </Typography>
                    <form autoComplete="false">
                        <TextField
                            value={description}
                            id="outlined-multiline-static"
                            // label="Тайлбар"
                            placeholder="Тайлбар"
                            fullWidth
                            name="description"
                            multiline
                            rows={2}
                            onChange={handleInputChange}
                            error={Boolean(errors.description)}
                            helperText={errors.description}
                            style={{ marginTop: '15px' }}
                        />
                        <div className="epg-modal-footer">
                            <Button
                                type="submit"
                                variant="outlined"
                                autoFocus
                                color="success"
                                onClick={handleDisapprove}
                            >
                                Илгээх
                            </Button>
                            <Button
                                variant="outlined"
                                autoFocus
                                color="error"
                                onClick={handleDecsClose}
                            >
                                Болих
                            </Button>
                        </div>
                    </form>
                </Box>
            </Modal>

            <Modal
                open={approveOpen}
                onClose={handleApproveClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="epg-detail-disapprove-modal epg-detail-modal">
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        "{filename}" - Энэ хөтөлбөрийг батлах уу?
                    </Typography>

                    <div className="epg-modal-footer">
                        <Button
                            type="submit"
                            variant="outlined"
                            autoFocus
                            color="success"
                            onClick={handleApprove}
                        >
                            Батлах
                        </Button>
                        <Button
                            variant="outlined"
                            autoFocus
                            color="error"
                            onClick={handleApproveClose}
                        >
                            Болих
                        </Button>
                    </div>
                </Box>
            </Modal>
        </Grid>
    );
}
